module.exports = __webpack_public_path__ + "w.no2.2125cd47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/w.no2.jpg
// module id = SwK8
// module chunks = 0